import { Component, OnInit, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { ExcelUtility } from '../../../../common/util/ExcelUtility';
import { ReturnStoreFacade } from '../../../../common/facade/ReturnStoreFacade';
import { Strings } from '../../../../common/language/strings';
import { res } from '../../../../common/language/text/res';
import { ActivatedRoute, NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-return-store-detail',
  templateUrl: './return-store-detail.component.html',
  styleUrls: ['./return-store-detail.component.css']
})
export class ReturnStoreDetailComponent implements OnInit {
  titleReturn = res.Return;
  lblDownload = res.Download;
  lblOriginStore = res.OriginStore;
  lblShippingType = res.ShippingType;
  lblReasonForReturn = res.ReasonForReturn;
  lblSendDate = res.SendDate;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblBrand = res.Brand;
  lblStyleVariety = res.StyleVariety;
  lblSize = res.Size;
  lblAmountSent = res.AmountSent;

  isSpanish = true;
  language = 0;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // table
  rows: any[];
  _filteredData: any[];
  editing = {};
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];

  returnStore: any;
  returnStoreId = '';
  storeOrigin = '';
  shippingType = '';
  shippingDate = '';
  reasonReturn = '';
  public extras: NavigationExtras;
  public path = 'return/return-store';
  storeId = -1;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _returnStoreFacade: ReturnStoreFacade,
    private _excel: ExcelUtility,
    private _activatedRoute: ActivatedRoute,
    public strings: Strings
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }

    const navigation = this._activatedRoute.queryParams.subscribe(params => {
      this.storeId = Number(params['storeId']);
      this.extras = {
          queryParams: {
              'storeId': this.storeId,
              'startDate': params['startDate'],
              'endDate': params['endDate'],
              'selectedOrganizations': params['selectedOrganizations']
          }
      };
    });

    this.getReturnRequestDet();
  }

  private getReturnRequestDet() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.returnStoreId = id;
    this._returnStoreFacade.GetReturnStoreDetail(id, this.language).subscribe(
      response => {
        this.loading = false;
        this.returnStore = response.data;
        this.storeOrigin = response.data.storeName;
        this.shippingType = response.data.shippingType;
        this.shippingDate = response.data.shippingDate;
        this.reasonReturn = response.data.comment;
        this.rows = response.data.detail;
        this._filteredData = response.data.detail;
        this.fillSpinners();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertReturnDetailCouldNotBeObtained), 'danger');
      }
    );
  }

  private fillSpinners() {
    this._filteredData.forEach(x => {
      if (!this.genders.includes(x.gender)) {
        this.genders.push(x.gender);
      }
      if (!this.styles.includes(x.styleVariety)) {
        this.styles.push(x.styleVariety);
      }
      this.loading = false;
    });
  }

  onGenderChange() {
    this.style = '-1';
    if (this.gender.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.gender.toString() === this.gender.toString());
      });
    }
  }

  onStyleChange() {
    this.gender = '-1';
    if (this.style.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.styleVariety.toString() === this.style.toString());
      });
    }
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {

        const info = {
          [this.strings.GetText(res.Brand)]: row.brand,
          [this.strings.GetText(res.Gender)]: row.gender,
          [this.strings.GetText(res.StyleVariety)]: row.styleVariety,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.AmountSent)]: row.quantity
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.Return) + ': ' + this.returnStoreId);
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
